
import {defineComponent, PropType} from "vue";
import FooterComponent from "@/components/recorder/partials/FooterComponent.vue";
import {Campaign} from "@/models/campaign";
import FullHeaderComponent from "@/components/recorder/partials/FullHeaderComponent.vue";

export default defineComponent({
    name: 'InactiveComponent',
    components: {FullHeaderComponent, FooterComponent},
    props: {
        campaign: Object as PropType<Campaign>,
    },
});
